export default {"src":"/_next/static/media/header_finished.1cb9d679.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};